module.exports = __webpack_public_path__ + "img/bookjoy_logo_login.991bb980.svg";